export function parseApiError(body: unknown, fallback = 'Request failed'): string {
  if (body && typeof body === 'object') {
    if ('error' in body && typeof body.error === 'string' && body.error !== 'invalid_request') {
      return body.error;
    }
    if ('details' in body && body.details && typeof body.details === 'object' && 'formErrors' in body.details) {
      const formErrors = body.details.formErrors;
      if (Array.isArray(formErrors) && typeof formErrors[0] === 'string') {
        return formErrors[0];
      }
    }
    if ('details' in body && body.details && typeof body.details === 'object' && 'fieldErrors' in body.details) {
      const fieldErrors = body.details.fieldErrors;
      if (fieldErrors && typeof fieldErrors === 'object') {
        for (const messages of Object.values(fieldErrors as Record<string, unknown>)) {
          if (Array.isArray(messages) && typeof messages[0] === 'string') {
            return messages[0];
          }
        }
      }
    }
  }
  return fallback;
}

export async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, { credentials: 'same-origin', ...init });
  const body: unknown = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(parseApiError(body, `Request failed (${response.status})`));
  }
  return body as T;
}
